var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileAlertOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 21.7H16.2V11.9H13.95V21.7ZM15 27.9C15.4 27.9 15.75 27.75 16.05 27.45C16.35 27.15 16.5 26.8 16.5 26.4C16.5 26 16.35 25.65 16.05 25.35C15.75 25.05 15.4 24.9 15 24.9C14.6 24.9 14.25 25.05 13.95 25.35C13.65 25.65 13.5 26 13.5 26.4C13.5 26.8 13.65 27.15 13.95 27.45C14.25 27.75 14.6 27.9 15 27.9ZM2.9 38C2.1 38 1.41667 37.7167 0.85 37.15C0.283334 36.5833 0 35.9 0 35.1V11.4L11.4 0H27.1C27.9 0 28.5833 0.283333 29.15 0.85C29.7167 1.41667 30 2.1 30 2.9V35.1C30 35.9 29.7167 36.5833 29.15 37.15C28.5833 37.7167 27.9 38 27.1 38H2.9ZM2.9 35.75H27.1C27.2667 35.75 27.4167 35.6833 27.55 35.55C27.6833 35.4167 27.75 35.2667 27.75 35.1V2.9C27.75 2.73333 27.6833 2.58333 27.55 2.45C27.4167 2.31667 27.2667 2.25 27.1 2.25H12.4L2.25 12.4V35.1C2.25 35.2667 2.31667 35.4167 2.45 35.55C2.58333 35.6833 2.73333 35.75 2.9 35.75ZM2.9 35.75H2.25H27.75H27.1H2.9Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAlertOutlined);
export default __webpack_public_path__ + "static/media/FileAlertOutlined.8219b30a.svg";
export { ForwardRef as ReactComponent };